import { AntibioticsCreate } from "./AntibioticsCreate";
import { AntibioticsList } from "./AntibioticsList";
import { AntibioticsShow } from "./AntibioticsShow";
import { AntibioticsEdit } from "./AntibioticsEdit";

export const antibiotics = {
  list: AntibioticsList,
  create: AntibioticsCreate,
  edit: AntibioticsEdit,
  show: AntibioticsShow,
};
